import imgJesus from "../../../img/equipe/Jesus.jpg";

const CardJesus = () => {
    return (
        <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item rounded">
                <div className="team-img rounded-top h-100">
                    <img src={imgJesus} className="img-fluid rounded-top w-100" alt="" />
                </div>
                <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                    <h5>Jesus Cristo</h5>
                    <p className="mb-0">Nosso Coordenador</p>
                </div>
            </div>
        </div>
    );
}

export default CardJesus;